<template>
  <v-snackbar
      top
      v-model="globalSnackbar"
      :color="globalSnackbarType"
  >
    {{ globalSnackbarMessage }}

    <template v-slot:action="{ attrs }">
      <v-btn
          text
          v-bind="attrs"
          @click="globalSnackbar = false"
      >
        Fechar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  mounted() {
    this.$root.$on('GlobalSnackbar', (params) => {
      this.globalSnackbarType = params.type ? params.type : this.globalSnackbarType;
      this.globalSnackbarMessage = params.message;
      this.globalSnackbar = true;
    });
  },
  data: function() {
    return {
      globalSnackbarType: 'info',
      globalSnackbarMessage: '',
      globalSnackbar: false
    };
  }
}
</script>

<style>
</style>
